import React from 'react';
import { Clock, Sparkles } from 'lucide-react';
import EmptyState from '../../../../components/common/EmptyState';

interface EmptyNoHistoryProps {
  onStartCleanup: () => void;
}

export default function EmptyNoHistory({ onStartCleanup }: EmptyNoHistoryProps) {
  return (
    <EmptyState
      icon={<Clock size={48} strokeWidth={1.75} />}
      title="No cleanups yet"
      description="When Vela archives unused accounts, merges duplicates, or categorizes transactions for you (or you do it yourself), it'll show up here so you can review or undo."
      action={{
        label: 'Start a Vela cleanup',
        onClick: onStartCleanup,
        icon: <Sparkles size={16} />,
      }}
    />
  );
}